import React, { Component } from "react";
import { PropTypes } from 'prop-types';
import withRouter from "../../withRouter";
import { BrokerPrivacyPolicy } from "./brokerPrivacyPolicy";
import $ from "jquery";
import { OBQrcode } from "../openBanking/obqrcode";
import { obVerificationLinkSentToMobile } from "../../action/application/obVerificationLink";
import { handleStatusCode } from '../../utils/handleStatusCode';
import Cookies from "universal-cookie";
import parse from 'html-react-parser';
import { getWebTokenOb } from "../../action/application/getToken";
import { getStatusResultOb } from "../../action/application/getObResult";
import { getBrokerUserDetails } from "../../action/application/getBrokerUserDetails";
import { getEmailFromStorage, setSessionIdInStorage } from "../../utils/helpers/storageUtils";


export class OpenBankingConsent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      howDoesWork: "",
      preferNotUse: "",
      openBankingRedirectURLForBroker: "",
      width: window.innerWidth,
      serverErrorMessage: "",
      redirectUrl: "",
      buttonLabel: "",
      message_title: "",
      message: "",
      OBdisableButton: false,
      ObToken: "",
      qrinterval: false,
      isShowPopUp: false,
      qrScanned: false,
      greater: false,
      phoneNo: props.phoneNo || '',
      isObRedirect:false,
      email: ''
    }
    this.loading = false;
    this.loadData = this.loadData.bind(this);
  }


  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);   
    if (sessionStorage.getItem('isObFlow')) {
      this.getPhoneNo();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showQrScannedPopup !== prevState.showQrScannedPopup) {
      document.body.style.overflow = this.state.showQrScannedPopup ? 'hidden' : 'auto';
    }
    const email = getEmailFromStorage();
    if (email && email !== this.state.email) {
      this.setState({ email: email });
    }
    if (this.state.email !== prevState.email && sessionStorage.getItem('applicationId') && !this.state.ObToken) {
      this.generateToken().catch(error => { console.log(error) });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
    document.body.style.overflow = 'auto';
     
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
      this.setState({ qrinterval: false });
    }
  }

  getApplicationIDInstorageForOB() {
    const cookie = new Cookies();
    return sessionStorage.getItem('applicationId') ? sessionStorage.getItem('applicationId') : cookie.get('applicationId')
  }

  //function to get ob token from backend
  generateToken = async () => {
    try {
      let obj = {};
      let applicationId = sessionStorage.getItem('applicationId');
      let applicationExternalId = sessionStorage.getItem('application_id');
      const isValidApplicationId = Number(applicationId);
      const email = getEmailFromStorage() || '';

      obj= {
        application_id : isValidApplicationId ? applicationId : '',
        application_external_id : isValidApplicationId ? '' : applicationExternalId,
        email : email
      }
      const result = await getWebTokenOb(obj);
      let token = result.data.data?.token;
      this.setState({ ObToken: token });
      this.callevent();
    } catch (error) {
      console.log(error)
    }
  }

  callevent = async () => {
    if (this.state.qrinterval === false) {
      this.interval = setInterval(this.loadData, 30000);
      this.setState({ qrinterval: true });
    }
  }

  loadData = async () => {
    if (this.loading) return;
    this.loading = true;
    try {
      if (this.state.isShowPopUp === true) {
        this.setState({ greater: true });
        clearInterval(this.interval);
        return
      }
      if (this.state.greater === false) {
        let applicationId = await this.getApplicationIDInstorageForOB();
        let applicationExternalId = sessionStorage.getItem('application_id');
        const isValidApplicationId = Number(applicationId);
        const email = getEmailFromStorage() || '';
        let obj = {
          application_id: isValidApplicationId ? applicationId : '',
          application_external_id: isValidApplicationId ? '' : applicationExternalId,
          email: email
        }
        let obResponse = await getStatusResultOb(obj);        
        if (!obResponse?.data) {
          console.log("API returned undefined or invalid response");
          return; // stop further processing
        }
        if (obResponse.data.data.isShowPopup) {
          await this.handleGetObResult(obResponse);
          this.setState({ isShowPopUp: true });
        }
        if(obResponse.data.data.isQrScanned) {
          this.setState({ qrScanned: true });
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false; // release the flag
    }
  }

  obVerificationLinkForUser = async () => {
    this.setState({ OBdisableButton: true });
    let email = getEmailFromStorage();
    const requestPayload = {
      "application_id": await this.getApplicationIDInstorageForOB(),
      "email": email,
      "mobile_number": sessionStorage.getItem('mobileNumber'),
      "userId": sessionStorage.getItem('userID'),
      "flow": (localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now') ? true : false
    }
    const responseResult = await obVerificationLinkSentToMobile(requestPayload);
    if (responseResult.data.statusCode === 200) {
      if (responseResult.data.data.isSendLink) {
        // disable the send button as the mitek Verification link is already sent for the user
        this.props.handleLoader(false);
        this.setState({ serverErrorMessage: responseResult.data.message, OBdisableButton: true });
        window.$('#OBserverErrorShowModel').modal('show');

      }
      else {
        this.props.handleLoader(false);
        this.setState({ serverErrorMessage: responseResult.data.message, OBdisableButton: false });
        window.$('#OBserverErrorShowModel').modal('show');

      }
    }
    else if (handleStatusCode(responseResult.data.statusCode)) {
      this.props.handleLoader(false);
      this.setState({ serverErrorMessage: responseResult.data.message, loading: false, OBdisableButton: true });
      window.$('#OBserverErrorShowModel').modal('show');
    }
  }

  handleObVerificationLinkPopUp = async () => {
    // Hide your modal
    window.$('#OBserverErrorShowModel').modal('hide');
    // Manually remove backdrop and body class if needed
    window.$('.modal-backdrop').removeClass('show');
    window.$('body').removeClass('modal-open');
    window.$('.modal-backdrop').remove();
  }

  //function to handle response from getobresult
  handleGetObResult = async (obResponse) => {
    if (obResponse.data.data.isShowPopup) {
      if (obResponse.data.data.redirectUrl != null && obResponse.data.data.redirectUrl != undefined && obResponse.data.data.redirectUrl != '') {
        this.setState({ message: obResponse.data.message, message_title: obResponse.data.data.message_title, redirectUrl: obResponse.data.data.redirectUrl, buttonLabel: obResponse.data.data.buttonLabel });
        sessionStorage.setItem('isObFlow', 'false');
        window.$('#OBSucesssModal').modal('show');
      }
      else {
        this.setState({ Message: obResponse.data.data.message, message_title: obResponse.data.data.message_title });
        window.$('#OBSucesssModal').modal('show');
      }
    }
  }

  handleOBsucessmodal = async () => {
    window.$('#OBserverErrorShowModel').modal('hide');
    if (this.state.redirectUrl != null && this.state.redirectUrl != undefined && this.state.redirectUrl != "") {
      let newURL = this.state.redirectUrl;
      setTimeout(() => {
        window.location.replace(newURL);
      }, 200)

    }
  }

  getPhoneNo = async () => {
    const application_Id = this.getApplicationIDInstorageForOBflow();
    const response = await getBrokerUserDetails(application_Id);
    if (response.data.data.mobile) {
      const phoneNo = response.data.data.mobile;
      this.setState({ phoneNo: phoneNo });
      sessionStorage.setItem('mobileNumber', phoneNo);
      setSessionIdInStorage(response.data.data.sessionId);
    }
  }

  getApplicationIDInstorageForOBflow() {
    return sessionStorage.getItem('applicationId');
  }

  checkIfMitekIsEligible = async () => {
    this.props.handleLoader(true);
    let applicationId = await this.getApplicationIDInstorageForOB();
    let applicationExternalId = sessionStorage.getItem('application_id');
    const isValidApplicationId = Number(applicationId);
    const email = getEmailFromStorage() || '';
    let obj= {
        application_id : isValidApplicationId ? applicationId : '',
        application_external_id : isValidApplicationId ? '' : applicationExternalId,
        email : email
      }
    let obResponse = await getStatusResultOb(obj);
    
    if (obResponse.data.data?.isQrScanned) {
      this.setState({ 
        showQrScannedPopup: true,
        qrScanned: true
      });
    } else {
      let redirectToMitekPage= await this.props.redirectToMitekPage();
	  if(redirectToMitekPage.status){
		this.setState({greater:true})
      }
	}
    this.props.handleLoader(false);
  }

  handleObRedirect = async () => {
    await this.props.handleObredirect(true);
    let redirectToOpenBanking = await this.props.redirectToOpenBanking()
    if (redirectToOpenBanking.status) {
      this.setState({ greater: true })
    }
  }
 handleOpenBankingredirect = async () => {
    await this.props.handleObredirect(true);  
    this.props.redirectToOpenBanking();
  }
  renderCommonAccordions() {
    return (
      <>
        <div className="row">
          <div className="accordion" id="accordionHowWorks">
            <div className="accordion-item rounded-3 border-0 shadow mb-2 howdoeswork">
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${this.state.howDoesWork == "show" ? "" : "collapsed"} fw-semibold ob-howworks-section d-flex justify-content-start gap-3`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#acc-collapseOne"
                  aria-expanded="false"
                  aria-controls="acc-collapseOne"
                  onClick={() =>
                    this.setState(prev => ({
                      howDoesWork: prev.howDoesWork === "show" ? "" : "show"
                    }))
                  }
                >
                  <img src="images/icon-how-works.png" alt="how" />
                  <h4>How does it work?</h4>
                </button>
              </h2>
              <div id="acc-collapseOne" className={`accordion-collapse collapse ${this.state.howDoesWork}`} data-bs-parent="#accordionHowWorks">
                <div className="accordion-body">
                  <p>humm uses Bud analysis and reports to support your loan application.</p>
                  <p>Bud works with Open Banking technology which is backed by the government of all UK and Irish Banks.</p>
                  <p>With Open Banking you can securely share your account history directly from your banks. It’s just like sharing copies of your bank statements, but easier, faster and safer. There’s no impact on your credit file.</p>
                  <p>We process hundreds of reports a day and most are completed in less than 3 minutes.</p>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="row">
          <div className="col-lg-12 ob-nottouse-section">
            <div className="accordion" id="accordionOBNotToUse">
              <div className="accordion-item rounded-3 border-0 shadow mb-2 howdoes">
                <h2 className="accordion-header prefer-not-use">
                  <button
                    className="accordion-button collapsed fw-semibold ob-nottouse-head d-flex justify-content-start gap-3"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#acc-collapseTwo"
                    aria-expanded="false"
                    aria-controls="acc-collapseTwo"
                    onClick={() =>
                    this.setState(prev => ({
                      preferNotUse: prev.preferNotUse === "show" ? "" : "show"
                    }))
                  }
                  >
                    <h4>I prefer not to use open banking</h4>
                  </button>

                  {this.state.preferNotUse == "show" ? (
                    <button
                      className="accordion-plusminus-button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ preferNotUse: "" });
                      }}
                    >
                      <img src="images/iocn-accordion-minus.svg" alt="img" />
                    </button>
                  ) : (
                    <button
                      className="accordion-plusminus-button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ preferNotUse: "show" });
                      }}
                    >
                      <img src="images/iocn-accordion-plus.svg" alt="img" />
                    </button>
                  )}
                </h2>

                <div id="acc-collapseTwo" className={`accordion-collapse collapse ${this.state.preferNotUse}`} data-bs-parent="#accordionOBNotToUse">
                  <div className="accordion-body ob-nottouse-content">
                    <p>
                      This means your application will go to be reviewed manually by an underwriter who may need to request further documents manually via
                      email. This option will delay a decision compared to Open Banking.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {this.state.preferNotUse == "show" && (
              <div className="ob-nottouse-button d-flex justify-content-center align-items-center">
                <button className="btn btn-outline-warning without-btn" onClick={(e) => {
                  e.preventDefault();
                  this.checkIfMitekIsEligible()
                }}>
                  Continue without
                </button>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
  renderForLargeView() {
    return (
      <div className="row ob-spacing">
        <div className="col-lg-12 ob-desc-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 ob-description">
                <p>We just need some additional information to process your application. humm uses technology via Bud to provide the quickest, simplest, and most secure way to share this information. It's just like sharing copies of your bank statements.</p>
                <p>Bud will securely transfer you to your bank who will prompt you to log in.</p>
              </div>
              <div className="col-lg-12 mobile-ob-description">
                <p>We just need some additional information to process your application.</p>
                <p>humm uses technology via Bud to provide the quickest, simplest, and most secure way to share this information. It's just like sharing copies of your bank statements.</p>

              </div>
            </div>
            <div className="row ob-cta-section-web">
              <div className="col-lg-12 ob-cta-section d-flex justify-content-center">
                <div className="ob-cta-inner-section ">
                  <span className="ob-cta-legend-title">Recommended</span>

                  <div className="col-lg-12">

                    <div className={`row ${this.state.width <= 992 ? "d-flex flex-column align-items-center" : ""}`}>

                      <div className="col-lg-8 ">


                        <div className=''>
                          {/* <div className='col-md-6 col-sm-0 border'></div> */}
                          <div className='col-md-12 col-sm-12 '>

                            <div className='d-flex flex-coloumn justify-content-center align-items-center'>
                              <div className='d-flex align-items-center justify-content-center '>
                                {/* <div className='qrcode-consent-text mb-4'>
                                            Scan the QR code below using your mobile device or enter your mobile number to complete this step. Please have your passport or driving licence ready for verification.
                                          </div> */}
                              </div>

                              <div className="mitek-consent-page-two-section d-flex flex-column align-items-center justify-content-center" style={{ backgroundColor: '#ffffffff' }}>

                                <div className="mx-auto">
                                  <p className="text-center">
                                    For public or shared devices, please scan the QR code or<br />
                                    <p className="text-center"> Click Send SMS to complete this step on your mobile device </p>
                                  </p>
                                </div>

                                <div className="d-flex align-items-center gap-4 custom-gap">

                                  <div className='qrcode-display'>

                                    <div className='qrcode-option'>
                                      <OBQrcode handleLoader={this.props.handleLoader} ObToken={this.state.ObToken} qrScanned={this.state.qrScanned} handleGetObResult={this.handleGetObResult} />
                                    </div>

                                  </div>

                                  <div className='separate-section seperation-line'>
                                    <span className='vertical-line'></span>
                                    <h3 className='or-subtext'>OR</h3>
                                    <span className='vertical-line'></span>
                                  </div>

                                  <div
                                    className={`smslink-option ${this.state.width <= 1268 ? 'mt-4' : ''}`}
                                    style={{ width: this.state.width <= 1268 ? 'auto' : '250px' }}>
                                    <form>
                                      <div className="form-group identity-doc-form identity-doc-form-web">
                                        <label htmlFor="phoneNumber" className='text-left d-block mb-2'>Phone Number</label>
                                        <input

                                          type="text"
                                          id='phoneNumber'
                                          value={this.state.phoneNo || this.props.phoneNo}
                                          name="phoneNo"
                                          disabled
                                          className="form-control form-control-web"
                                          placeholder="Enter here"

                                          style={{ backgroundColor: '#e2dedeff' }}
                                        />
                                      </div>
                                    </form>

                                    <div className="next-btn text-center">
                                      <button
                                        type="button"
                                        style={{ backgroundColor: "#ff6c00" }}
                                        disabled={this.state.OBdisableButton}
                                        className="btn btn-primary btn-primary-web"
                                        id="btn-one"
                                        onClick={() => { this.obVerificationLinkForUser() }}
                                      >
                                        Send SMS
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className=' separate-section-ob col-lg-1'>
                        <span className='vertical-line-ob'></span>

                        <span className='vertical-line-ob'></span>
                      </div>

                      <div className="col-lg-3  d-flex flex-column align-items-center justify-content-center ">
                        {/* 
                    <div className="ob-cta-title d-flex justify-content-center gap-2">
                      <img src="images/icon-flash.png" alt="OB"/>
                      <h4>Open Banking</h4>
                    </div> */}
                        <div className="ob-cta-desc mt-5">
                          <p className="text-center">Click below to continue on this device. Not recommended for public or shared devices </p>
                        </div>
                        <div className="mobile-ob-cta-desc">
                          <p className="text-center">Bud will securely transfer you to your bank who <br /> will prompt you to log in. </p>
                        </div>
                        <div className="ob-cta-button d-flex justify-content-center mt-5 ob-cta-button-web">
                          <button className="btn btn-warning continue-banking btn-warning-web" onClick={this.handleObRedirect}>Proceed on this device</button>
                        </div>

                      </div>

                    </div>



                  </div>


                </div>
              </div>
            </div>
            <div className="row">
              <div className="accordion accordion-web" id="accordionHowWorks">
                <div className="accordion-item rounded-3 border-0 shadow mb-2 howdoeswork accordion-item-web">
                  <h2 className="accordion-header accordion-header-web">
                    <button className={`accordion-button ${this.state.howDoesWork == "show" ? "" : "collapsed"} fw-semibold  ob-howworks-section d-flex justify-content-start gap-3 accordion-button-web`} type="button" data-bs-toggle="collapse" data-bs-target="#acc-collapseOne" aria-expanded="false" aria-controls="acc-collapseOne" onClick={() => { this.setState({ howDoesWork: this.state.howDoesWork == "show" ? "" : "show" }) }}>
                      <img src="images/icon-how-works.png" alt="how" />
                      <h4>How does it work?</h4>
                    </button>
                  </h2>
                  <div id="acc-collapseOne" className={`accordion-collapse collapse ${this.state.howDoesWork} accordion-collapseOne-web`} data-bs-parent="#accordionHowWorks">
                    <div className="accordion-body accordoin-body-web">
                      <p>humm uses Bud analysis and reports to support your loan application.</p>
                      <p>Bud works with Open Banking technology which is backed by the government of all UK and Irish Banks.</p>
                      <p>With Open Banking you can securely share your account history directly from your banks. It’s just like sharing copies of your bank statements, but easier, faster and safer. There’s no impact on you credit file.</p>
                      <p>We process hundreds of reports a day and most are completed in less than 3 minutes.</p>
                    </div>

                  </div>
                </div>
              </div>


            </div>
            {<div className="row">
              <div className="col-lg-12 ob-nottouse-section ob-nottouse-web">
                <div className="accordion" id="accordionOBNotToUse">
                  <div className="accordion-item rounded-3 border-0 shadow mb-2 howdoes howdoes-web">
                    <h2 className="accordion-header prefer-not-use accordion-header-web">
                      <button className="accordion-button collapsed fw-semibold  ob-nottouse-head d-flex justify-content-start gap-3 accordion-button-web" type="button" data-bs-toggle="collapse" data-bs-target="#acc-collapseTwo" aria-expanded="false" aria-controls="acc-collapseTwo" onClick={() => { this.setState({ preferNotUse: this.state.preferNotUse == "show" ? "" : "show" }) }}>
                        <h4>I prefer not to use open banking</h4>
                      </button>
                      {this.state.preferNotUse == "show" ? <button className="accordion-plusminus-button" onClick={(e) => { e.preventDefault(); this.setState({ preferNotUse: this.state.preferNotUse == "show" ? "" : "show" }) }}><img src="images\iocn-accordion-minus.svg" alt="img"></img></button> : <button className="accordion-plusminus-button" onClick={(e) => { e.preventDefault(); this.setState({ preferNotUse: this.state.preferNotUse == "show" ? "" : "show" }) }}><img src="images\iocn-accordion-plus.svg" alt="img"></img></button>}

                    </h2>

                    <div id="acc-collapseTwo" className={`accordion-collapse collapse ${this.state.preferNotUse} accordionOBNOToUse-web`} data-bs-parent="#accordionOBNotToUse">
                      <div className="accordion-body ob-nottouse-content ob-nottouse-content-web">
                        <p>This means your application will go to be reviewed manually by an underwriter who may need to request further documents manually via email. This option will delay a decision compared to Open Banking.</p>
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.preferNotUse == "show" &&
                  <div className="ob-nottouse-button d-flex justify-content-center align-items-center ob-nottouse-web">
                    <button className="btn btn-outline-warning without-btn outline-web" onClick={(e) => {
                      e.preventDefault();
                      this.checkIfMitekIsEligible()
                    }}>Continue without</button>
                  </div>
                }
                {this.state.showQrScannedPopup && (
                  <>
                    <div className="modal-backdrop fade show"></div>
                    <div className="modal fade show model-error" id="OBserverErrorShowModel"
                      tabIndex="-1" role="dialog" aria-hidden="true" aria-labelledby="OBserverErrorShowModellLabel"
                      style={{ display: 'block', pointerEvents: 'auto' }}
                    >
                      <div className={`modal-dialog ${this.state.width < 910 ? 'mx-3' : ''}`} role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                          </div>
                          <div className="modal-body">
                            <div className="logo">
                              <img src="images/modal-logo.svg" alt="logo" className="img-fluid" />
                            </div>
                            <h5 className="modal-title " id="serverErrorShowModelLabel">Open Banking Already Chosen</h5>
                            <p className="text-center mt-4 mx-3">Open Banking is in progress on the customer's device</p>
                          </div>

                          <div className="modal-footer mb-4">
                            <button type="button" className="btn btn-primary" data-dismiss="modal"
                              onClick={() => this.setState({ showQrScannedPopup: false })}>Ok</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    )
  }

  renderForSmallView() {
    return (
      <div className="row">
        <div className="col-lg-12 ob-desc-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 ob-description">
                <p>We just need some additional information to process your application. humm uses technology via Bud to <br />provide the quickest, simplest, and most secure way to share this information. It's just like sharing copies of<br /> your bank statements.</p>
              </div>
              <div className="col-lg-12 mobile-ob-description">
                <p className="text-center">We just need some additional information to process your application.</p>
                <p className="text-center">humm uses technology via Bud to provide the quickest, simplest, and most secure way to share this information. It's just like sharing copies of your bank statements.</p>
                <p className="text-center">Bud will securely transfer you to your bank who will prompt you to log in.</p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 ob-cta-section d-flex justify-content-center">
                <div className={`ob-cta-inner-section ${this.state.width > 681 ? 'ob-cta-inner-section-over' : ''}`}>
                  <div>
                    <p className="text-center">Click below to continue on this<br />device. Not recommended for<br />public or shared devices </p>
                  </div>
                  <div className="ob-cta-button d-flex justify-content-center">
                    <button className="btn btn-warning continue-banking" onClick={(e) => { this.props.redirectToOpenBanking() }}>Proceed on this device</button>
                  </div>
                  <hr className="ob-divider" />
                  <div>
                    <form>
                      <div className="form-group identity-doc-form">
                        <label htmlFor="phoneNumber" className='text-left d-block mb-2'>Phone Number</label>
                        <input
                          type="text"
                          id='phoneNumber'
                          value={this.state.phoneNo || this.props.phoneNo}
                          name="phoneNo"
                          disabled={this.state.phoneNo || this.props.phoneNo ? true : false}
                          className="form-control"
                          placeholder="Enter here"
                          style={{ backgroundColor: '#e2dedeff' }}
                        />
                      </div>
                    </form>

                    <div className="next-btn text-center">
                      <button
                        type="button"
                        style={{ width: "190px" }}
                        disabled={this.state.OBdisableButton}
                        className="btn btn-warning continue-banking"
                        id="btn-one"
                        onClick={() => { this.obVerificationLinkForUser() }}
                      >
                        Send SMS
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.renderCommonAccordions()}
          </div>
        </div>
      </div>
    )
  }

  renderForNormalView() {
    return (
      <div className="row">
        <div className="col-lg-12 ob-desc-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 ob-description">
                <p>We just need some additional information to process your application. humm uses technology via Bud to <br />provide the quickest, simplest, and most secure way to share this information. It's just like sharing copies of<br /> your bank statements.</p>
              </div>
              <div className="col-lg-12 mobile-ob-description">
                <p>We just need some additional information to process your application.</p>
                <p>humm uses technology via Bud to provide the quickest, simplest, and most secure way to share this information. It's just like sharing copies of your bank statements.</p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 ob-cta-section d-flex justify-content-center">
                <div className={`ob-cta-inner-section ${this.state.width > 681 ? 'ob-cta-inner-section-over' : ''}`}>
                  <span className={`ob-cta-legend-title ${this.state.width > 681 ? 'ob-cta-legend-title-over' : ''}`}>Recommended</span>
                  <div className={`ob-cta-title d-flex justify-content-center gap-2 ${this.state.width > 766 ? 'ob-cta-title-over' : ''}`}>
                    <img src="images/icon-flash.png" alt="OB" />
                    <h4>Open Banking</h4>
                  </div>
                  <div className={`ob-cta-desc ${this.state.width > 681 ? 'ob-cta-desc-over' : ''}`}>
                    <p className="text-center">Bud will securely transfer you to your<br />bank who will prompt you to log in. </p>
                  </div>
                  <div className="mobile-ob-cta-desc">
                    <p className="text-center">Bud will securely transfer you to your bank who <br /> will prompt you to log in. </p>
                  </div>
                  <div className="ob-cta-button d-flex justify-content-center">
                    <button className="btn btn-warning continue-banking" onClick={(e) => this.handleOpenBankingredirect(e)}>Continue with Open Banking</button>
                  </div>
                </div>
              </div>
            </div>
            {this.renderCommonAccordions()}
          </div>
        </div>
      </div>
    )

  } 
  
  renderViewBasedOnWidth = () => {
    const { width } = this.state;

    if (width > 680) {
      return this.renderForLargeView();
    } else if (width < 680) {
      return this.renderForSmallView();
    } else {
      return this.renderForNormalView();
    }
  }

  render() {
    return (
      <div className="openbanking-main">
        <BrokerPrivacyPolicy />

        <div className="row">
          <div className="col-lg-12 d-flex justify-content-center align-items-center title-section">
            <h2>Open Banking</h2>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 w-100 highlights-header">
            <div className="container">
              <div className="row">
                <div className="col-2 col-lg-2 adv-column d-flex align-items-center justify-content-center gap-5">
                  <img src="images/icon-safe.png" alt="safe" />
                  <h4>Safe</h4>
                </div>
                <div className="col-2 col-lg-3 d-flex align-items-center justify-content-center ">
                  <span className="seperator-line"></span>
                </div>
                <div className="col-3 col-lg-2 adv-column d-flex align-items-center justify-content-center gap-5">
                  <img src="images/icon-secure.png" alt="secure" />
                  <h4>Secure</h4>
                </div>
                <div className="col-2 col-lg-3 d-flex align-items-center justify-content-center ">
                  <span className="seperator-line"></span>
                </div>
                <div className="col-3 col-lg-2 adv-column d-flex align-items-center justify-content-center gap-5">
                  <img src="images/icon-fast.png" alt="fast" />
                  <h4>Quick</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        {
          this.renderViewBasedOnWidth()
        }
        {/* show server error message */}
        <dialog className="modal fade model-error" id="OBserverErrorShowModel" tabIndex="-1" data-keyboard="false" data-backdrop="static" aria-labelledby="OBserverErrorShowModellLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
              </div>
              <div className="modal-body">
                <div className="logo">
                  <img src="images/modal-logo.svg" alt="logo" className="img-fluid" />
                </div>
                {/* <h5 className="modal-title " id="serverErrorShowModelLabel">Message</h5> */}
                {/* Added the margin left and right spacing to message displayed in popup */}
                <p className="text-center mt-4 mx-3">{parse(this.state.serverErrorMessage)}</p>
              </div>

              <div className="modal-footer mb-4">
                <button type="button" className="btn btn-primary" data-dismiss="modal"
                  onClick={this.handleObVerificationLinkPopUp}>Ok</button>
              </div>


            </div>
          </div>
        </dialog>


        <div className="modal fade model-error" id="OBSucesssModal" tabIndex="-1" aria-labelledby="OBSucesssModalModel" aria-hidden="true" data-backdrop="false">
          <div className="modal-dialog">
            <div className="modal-content">

              <div className="modal-body">
                <div className="logo">
                  <img src="images/modal-logo.svg" alt="logo" className="img-fluid" />
                </div>
                {/* <h5 className="modal-title " id="mitekSucesssModal">{this.state.applicationStatusHeading}</h5> */}
                {this.state.message_title &&
                  <h5 className="modal-title message-title" id="OBSucesssModal">{this.state.message_title}</h5>
                }
                <p className="text-center">{parse(this.state.message)}</p>
              </div>
              <div className="modal-footer mb-4">
                <button className="btn btn-primary" onClick={this.handleOBsucessmodal}>
                  {this.state.buttonLabel ? this.state.buttonLabel : "Ok"}</button>
              </div>
            </div>
          </div>
        </div>

      </div>



    );
  }
}
OpenBankingConsent.propTypes = {
  redirectToOpenBanking: PropTypes.func,
  redirectToMitekPage: PropTypes.func,
  openBankingRedirectURL: PropTypes.string,
  handleLoader: PropTypes.func,
  phoneNo:PropTypes.string,
  handleObredirect: PropTypes.func
}

export default withRouter(OpenBankingConsent);